import { useSessionStorage, useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUiStore = defineStore('ui', () => {
  const fullscreen = ref(false)
  const blockScreen = ref(false) // full screen spinner
  /** Свёрнутый сайдбар (только иконки); preference пользователя. */
  const sidebarCollapsed = useLocalStorage('sidebar-collapsed', false)
  /** Алиас для существующих потребителей (signed.vue, sidebar*). */
  const sidebarIconOnly = sidebarCollapsed
  /** Поиск на стартовой странице (поле в шапке). */
  const homeSearch = ref('')
  const returnUrl = useSessionStorage('return-url', undefined, {
    serializer: {
      read: raw => (raw === undefined ? undefined : JSON.parse(raw)),
      write: val => (val === undefined ? undefined : JSON.stringify(val)),
    },
  })
  const listconfig = useLocalStorage('listconfig', {})

  /**
   * Переключает свёрнутость сайдбара.
   *
   * @returns {void}
   */
  function toggleSidebarCollapsed() {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }

  return {
    fullscreen,
    blockScreen,
    sidebarCollapsed,
    sidebarIconOnly,
    homeSearch,
    returnUrl,
    listconfig,
    toggleSidebarCollapsed,
  }
})
